var React = require('react');

function Sledding (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M400 128a48 48 0 1 0-48-48 48 48 0 0 0 48 48zm105 292.1a23.9 23.9 0 0 0-33.9 0c-12.1 12.1-30.5 15.4-45.1 8.7L35 226.6a24 24 0 0 0-22 42.7l391.9 202.6A88.06 88.06 0 0 0 442 480a89 89 0 0 0 63-26 24.08 24.08 0 0 0 0-33.9z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M384.1 288v96c0 7.5-3 14-7.2 19.4L320 374v-54H215.47l-54.77-28.3a31.93 31.93 0 0 1 1.8-15.9 30.52 30.52 0 0 1 6.9-10.4l73.4-73.4H160a32 32 0 0 1 0-64h153.5a48 48 0 0 1 33.9 81.9L301.3 256h50.8a32 32 0 0 1 32 32z","className":"fa-primary","key":2})]);
}

Sledding.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Sledding;

Sledding.default = Sledding;
